module.exports = __webpack_public_path__ + "static/img/honor-7.97fd1a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/honor-7.png
// module id = HQVj
// module chunks = 0